import React, { useState } from "react";
import { Menu } from "lucide-react";
import UserSidebar from "../UserSidebar";

/**
 * Shared layout shell for every Vocabulary page.
 *
 * Props:
 *  - header      ReactNode  — content placed inside the sticky <header> (after the mobile toggle)
 *  - mainClassName string   — className for the <main> element (default: "flex-1 p-4 sm:p-6")
 *  - children    ReactNode  — page body
 */
export default function VocabLayout({ header, mainClassName = "flex-1 p-4 sm:p-6", children }) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div className="flex min-h-screen bg-gray-50">
      <UserSidebar isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />

      <div className="flex-1 lg:ml-72 flex flex-col">
        <header className="sticky top-0 z-30 bg-white border-b border-gray-200 px-4 py-3 flex items-center gap-3">
          <button
            className="lg:hidden p-2 rounded-xl hover:bg-gray-100 text-gray-600"
            onClick={() => setIsSidebarOpen(true)}
            aria-label="Mở menu"
          >
            <Menu size={20} />
          </button>
          {header}
        </header>

        <main className={mainClassName}>
          {children}
        </main>
      </div>
    </div>
  );
}
